<template>
  <div class="customer-detail">
    <v-skeleton-loader
      class="custom-skeleton my-3"
      v-if="pageLoading"
      type="article, list-item-two-line@3"
    >
    </v-skeleton-loader>

    <div v-else class="bg-white p-4 rounded-lg shadow-sm border mb-3">
      <!-- Section 1: Claim Details -->
      <div class="mb-4">
        <div class="d-flex align-items-center mb-3">
          <v-icon small color="indigo darken-4" class="mr-2"
            >mdi-sparkles</v-icon
          >
          <span
            class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
          >
            CLAIM DETAILS
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-office-building-outline</v-icon
            >
            <span class="text-secondary font-weight-500 font-size-14"
              >Company Name</span
            >
          </div>
          <span class="font-size-14 text-dark text-capitalize">
            <template v-if="claim && claim.company_name">{{
              claim.company_name
            }}</template>
            <template v-else
              ><em class="text-muted font-weight-normal"
                >no company name</em
              ></template
            >
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-tag-outline</v-icon
            >
            <span class="text-secondary font-weight-500 font-size-14"
              >Claim Category</span
            >
          </div>
          <span class="font-size-14 text-dark text-capitalize">
            <template v-if="claim && claim.category_name">{{
              claim.category_name
            }}</template>
            <template v-else
              ><em class="text-muted font-weight-normal"
                >no category name</em
              ></template
            >
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-credit-card-outline</v-icon
            >
            <span class="text-secondary font-weight-500 font-size-14"
              >Payment Mode</span
            >
          </div>
          <span class="font-size-14 text-dark text-capitalize">
            <template v-if="claim && claim.payment_mode_name">{{
              claim.payment_mode_name
            }}</template>
            <template v-else
              ><em class="text-muted font-weight-normal"
                >no payment mode name</em
              ></template
            >
          </span>
        </div>
      </div>

      <v-divider class="my-4"></v-divider>

      <!-- Section 2: Amount Details -->
      <div>
        <div class="d-flex align-items-center mb-3">
          <v-icon small color="indigo darken-4" class="mr-2"
            >mdi-cash-multiple</v-icon
          >
          <span
            class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
          >
            AMOUNT DETAILS
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-currency-usd</v-icon
            >
            <span class="text-secondary font-weight-500 font-size-14"
              >Currency</span
            >
          </div>
          <span class="font-size-14 text-dark">
            <template v-if="claim && claim.currency">{{
              claim.currency_name
            }}</template>
            <template v-else
              ><em class="text-muted font-weight-normal"
                >no currency</em
              ></template
            >
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-numeric</v-icon
            >
            <span class="text-secondary font-weight-500 font-size-14"
              >Amount</span
            >
          </div>
          <span class="font-weight-bold font-size-14 text-success">
            <template v-if="claim && claim.amount"
              >${{ claim.amount }}</template
            >
            <template v-else
              ><em class="text-muted font-weight-normal"
                >no amount</em
              ></template
            >
          </span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-calendar-outline</v-icon
            >
            <span class="text-secondary font-weight-500 font-size-14"
              >Claim Date</span
            >
          </div>
          <span class="font-size-14 text-dark">
            <template v-if="claim && claim.expense_date">{{
              claim.expense_date
            }}</template>
            <template v-else
              ><em class="text-muted font-weight-normal"
                >no claim date</em
              ></template
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactDetails",

  props: {
    claim: {
      type: Object,
      required: true,
    },
    pageLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
